import {Component, DestroyRef, EventEmitter, inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import {OfferStatusEnum} from "@app/enums/offer-status.enum";
import {ModalContainerComponent} from "@app/modal/modal-container/modal-container.component";
import {
  MedicalDevicesForPersonalOfferInterface,
  RedistributionRequestInterface
} from "@app/redistribution/redistribution.interface";
import {formatDate, NgIf} from "@angular/common";
import {
  RedistributionStatusComponent
} from "@app/redistribution/shared/redistribution-status/redistribution-status.component";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {RedistributionApiService} from "@app/redistribution/services/redistribution-api.service";
import {DropdownComponent} from "@app/dropdown/dropdown.component";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {DataService} from "@app/shared/data.service";
import {LoadingAnimationComponent} from "@app/loading-animation/loading-animation.component";
import {catchError, throwError} from "rxjs";
import {ToastService} from "@app/toast/toast.service";

@Component({
  selector: 'app-modal-put-personal-proposal',
  templateUrl: './modal-put-personal-proposal.component.html',
  styleUrls: ['./modal-put-personal-proposal.component.scss'],
  standalone: true,
  imports: [
    ModalContainerComponent,
    NgIf,
    RedistributionStatusComponent,
    ReactiveFormsModule,
    DropdownComponent,
    LoadingAnimationComponent
  ]
})
export class ModalPutPersonalProposalComponent implements OnInit {
  destroyRef = inject(DestroyRef);
  
  isOpen = false;
  
  form!: FormGroup
  
  _redistributionRequest!: RedistributionRequestInterface;
  @Input()
  set redistributionRequest(data: RedistributionRequestInterface) {
    this._redistributionRequest = data;
  }
  get redistributionRequest() {
    return this._redistributionRequest;
  }
  
  @Input() personalOffer!: any;
  @Input() offerStatus!: OfferStatusEnum;
  @Output() updateData = new EventEmitter<void>();
  
  @ViewChild('modalContainer') modalContainer!: ModalContainerComponent;
  
  userOrganisations: Array<{ [key: string]: string | number | any[]}> = [];
  userOrganisationsForList: Array<string> = [];
  
  medicatedMedicineMedicalDevicesForList: Array<string> = [];
  
  isLoading = false;
  
  maxAmount = Number.MAX_SAFE_INTEGER;
  maxAmount1 = Number.MAX_SAFE_INTEGER;
  maxAmountError = false;
  maxAmountError1 = false;
  
  medicalDevices = new Map();
  
  constructor(
      private fb: FormBuilder,
      private dataService: DataService,
      private redistributionApiService: RedistributionApiService,
      private toastService: ToastService,
  ) { }
  
  ngOnInit(): void {
    this.form = this.fb.group({
      offeredAmount: [null, [Validators.required, Validators.min(1)]],
      organizationId: [null, Validators.required],
      medicineMedicalDeviceId: [null, Validators.required],
    })
    
    // @ts-ignore
    this.form.controls['organizationId'].valueChanges
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((id: number) => {
          this.getMedicalDevices(id)
        })
  }
  
  open() {
    this.isOpen = true;
    
    this.dataService.userOrganizationsValue
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((data: Array<{ [key: string]: string | number | any[]}>) => {
          this.userOrganisations = data
          this.userOrganisationsForList = data
              .filter(item => item['id'] !== this.redistributionRequest.organizationId)
              .map(item => item['fullName'] as string)
        });
    
    this.modalContainer.openModal()
    this.form.reset(null)
    this.maxAmountError = false;
    this.maxAmountError1 = false;
    this.maxAmount = Number.MAX_SAFE_INTEGER;
    this.maxAmount1 = Number.MAX_SAFE_INTEGER;
    this.medicalDevices.clear()
  }
  
  close() {
    this.isOpen = false;
  }
  
  save() {
    this.form.markAllAsTouched();
    
    if (this.form.invalid || (this.maxAmountError)  ) {
      return;
    }
    
    if (this.maxAmountError && this.form.controls['offeredAmount'].value > this.maxAmount) {
      return;
    }
    
    if (this.maxAmountError1 && this.form.controls['offeredAmount'].value > this.maxAmount1) {
      return;
    }
    
    this.isLoading = true;
    this.redistributionApiService.putPersonalProposal({
          offeredAmount: this.form.controls['offeredAmount'].value,
          organizationId: this.form.controls['organizationId'].value,
          medicineMedicalDeviceId: this.form.controls['medicineMedicalDeviceId'].value,
          redistributionRequestId: this.redistributionRequest.id
        }
    )
        .pipe(
            catchError((error) => {
              this.isLoading = false;
              this.maxAmountError1 = false;
              this.maxAmountError = false;
              
              if (error.status === 400 && error.error.messages[1].includes('Operation is not allowed. Offered amount exceeds the available quantity at the ZOZ')) {
                const match = error.error.messages[1].match(/\d+/);
                this.maxAmount = match[0];
                this.maxAmountError = true;
              } else if (error.status === 400 && error.error.messages[1].includes('Operation is not allowed. Total offered amount exceeds medical good amount in parent request. Decrease the offered amount to proceed. Offered amount shall not exceed')) {
                const match = error.error.messages[1].match(/\d+/);
                this.maxAmount1 = match[0];
                this.maxAmountError1 = true;
              } else  {
                this.toastService.showError(error.error.messages[1]);
              }
              
              return throwError(() => error);
            })
        )
        .subscribe(() => {
          this.toastService.showSuccess('Запис успішно створено.');
          this.maxAmount = Number.MAX_SAFE_INTEGER;
          this.maxAmount1 = Number.MAX_SAFE_INTEGER;
          this.maxAmountError = false;
          this.maxAmountError1 = false;
          this.isLoading = false;
          this.updateData.emit();
          this.modalContainer.close();
          this.isOpen = false;
        })
    
  }
  
  cancel() {
    this.modalContainer.close();
    this.isOpen = false;
  }
  
  onSelectOrganization(e: string) {
    // @ts-ignore
    this.form.controls['organizationId'].setValue(this.userOrganisations.find(el => el['fullName'] === e)['id']);
  }
  
  getMedicalDevices(id: number) {
    if (!id) {
      return;
    }
    
    this.isLoading = true;
    this.redistributionApiService.getMedicalDevicesForPersonalOffer({
      dosage: this.redistributionRequest.dosage,
      mnn: this.redistributionRequest.mnn,
      direction: this.redistributionRequest.direction,
      organizationId: id,
      tradeName: this.redistributionRequest.tradeName
    })
        .pipe(
            catchError((error: Error) => {
              this.isLoading = false;
              return throwError(() => error);
            })
        )
        .subscribe(data => {
          this.medicalDevices.clear();
          
          for( let el of data) {
            let date = formatDate(new Date(el.dueDate), 'MM.yyyy', 'en-US');
            this.medicalDevices.set(`${date} - ${el.series}`, el.mmdId);
          }
          
          this.medicatedMedicineMedicalDevicesForList = [...this.medicalDevices.keys()];
          this.form.controls['medicineMedicalDeviceId'].reset(null);
          this.isLoading = false;
        })
  }
  
  onMedicalDevicesSelect(item: string) {
    let mmdId = this.medicalDevices.get(item)
    this.form.controls['medicineMedicalDeviceId'].setValue(mmdId);
  }
}
